export default {
      id: "icon-scoring-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-scoring",
      toString: function () {
        return this.url;
      }
    }